// Import Firebase functions (v9 modular SDK)
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    // apiKey: "AIzaSyA4ONgsHs0DcyT5CArDalIblXFxd_IgU2k",
    // authDomain: "chit-fund-application.firebaseapp.com",
    // databaseURL: "https://chit-fund-application-default-rtdb.asia-southeast1.firebasedatabase.app",
    // projectId: "chit-fund-application",
    // storageBucket: "chit-fund-application.firebasestorage.app",
    // messagingSenderId: "643010517478",
    // appId: "1:643010517478:web:a77a30d4049a86e49a5e27",
    // measurementId: "G-QB29PYX5LP"
    apiKey: "AIzaSyBQqGuCsGDLaonP6aTWbnOu8Rt3uyigq6I",
    authDomain: "ps-stores-26d8f.firebaseapp.com",
    projectId: "ps-stores-26d8f",
    storageBucket: "ps-stores-26d8f.firebasestorage.app",
    messagingSenderId: "1063842659510",
    appId: "1:1063842659510:web:f72103173833d348abfa17",
    measurementId: "G-K7RNCT7TQN"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Firebase Storage
const storage = getStorage(app);

// Export Firestore, Storage, and Auth
export { db, storage, auth };
